import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';
import { ToastrService } from 'ngx-toastr';
import { emailValidator } from 'src/app/shared/services/app-validators';

@Component({
  selector: 'app-request-demo',
  templateUrl: './request-demo.component.html',
  styleUrls: ['./request-demo.component.scss']
})
export class RequestDemoComponent implements OnInit {
  requestDemoForm: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private exclusiveService: ExclusiveService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.requestDemoForm = this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required]],
      mobile: ['', Validators.required],
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (!this.requestDemoForm.valid) {
      return;
    }
    const val = this.requestDemoForm.value;
    this.exclusiveService.addRequestDemo(
      val.firstname, val.lastname, val.email, val.mobile
    ).subscribe(
      (data: any) => {
        this.toastrService.success('Demo request submitted successfully!');
        this.requestDemoForm.reset();
        this.submitted = false;
      },
      (error: any) => {
        this.toastrService.error('Something went wrong. Please try again.');
      }
    );
  }
}
